import commandsModule from './commandsModule';
import toolbarModule from './toolbarModule';
import panelModule from './panelModule';

export default {
  id: 'mark',
  getToolbarModule: toolbarModule,
  getCommandsModule: commandsModule,
  getPanelModule: panelModule,
};
